
import React from 'react';
import {
    Box,
    Grid2,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import SubscribedCard from './SubscribedCard';
import { useParams } from 'react-router-dom';
import { useCourseDetail } from '../../assets/api/useGetApi';
import { TextSkeleton } from '../../shared/utils/SkeletonCom';

export const BulletList = ({ title, items }) => {
    return (
        <>
            <Typography variant="h5">{title}</Typography>
            <List>
                {Object.entries(items).map(([key, value], index) => (
                    <ListItem key={index} sx={{ alignItems: "flex-start" }}>
                        <ListItemIcon sx={{ minWidth: "20px", mt: "8px" }}> 
                            <FiberManualRecordIcon sx={{ fontSize: 10, color: "text.secondary" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body2" color="grey.400">
                                    {key} : {value}
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </>
    );
};
const UiUxDevelopement = () => {
    const { id } = useParams();
    const { data: coursesDetail, isLoading } = useCourseDetail(id);
    // const CourseStructure = [
    //     {
    //         title: "Lesson 1 : Design Thinking",
    //         content: "UI/UX development is the process of designing and building digital interfaces that enhance user interaction and experience. UI (User Interface) focuses on the visual and interactive elements, such as layouts, colors, typography, and buttons"
    //     },
    //     {
    //         title: "Lesson 2 : Ideation and Finding the user issues",
    //         content: "UI/UX development is the process of designing and building digital interfaces that enhance user interaction and experience. UI (User Interface) focuses on the visual and interactive elements, such as layouts, colors, typography, and buttons"
    //     },
    //     {
    //         title: "Lesson 3 : Wireframing",
    //         content: "UI/UX development is the process of designing and building digital interfaces that enhance user interaction and experience. UI (User Interface) focuses on the visual and interactive elements, such as layouts, colors, typography, and buttons"
    //     },
    //     {
    //         title: "Lesson 4 : Prototyping",
    //         content: "UI/UX development is the process of designing and building digital interfaces that enhance user interaction and experience. UI (User Interface) focuses on the visual and interactive elements, such as layouts, colors, typography, and buttons"
    //     },
    //     {
    //         title: "Lesson 5 : Testing",
    //         content: "UI/UX development is the process of designing and building digital interfaces that enhance user interaction and experience. UI (User Interface) focuses on the visual and interactive elements, such as layouts, colors, typography, and buttons"
    //     },
    // ]

    // const OutcomeList = ["UI/UX development is the process of designing ", "building digital interfaces that enhance user interaction", "UI/UX development is the process of designing ", "building digital interfaces that enhance user interaction"]
    return (
        <Grid2 container spacing={5}>
            <Grid2 children size={{ xs: 12, lg: 8 }}
                sx={{
                    maxHeight: { xs: "auto", lg: "70vh" },
                    overflowY: { xs: "auto", lg: "scroll" },
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                }}
            >

                {isLoading && <TextSkeleton line={1} width={"100%"} />}
                {!isLoading && <Typography variant='h1'>
                    {coursesDetail?.data?.title}
                </Typography>}
                {coursesDetail?.data?.description?.Objective && (
                    <Box my={5}>
                        <Typography variant="h5" >
                            Objective
                        </Typography>

                        {isLoading && <TextSkeleton line={4} width={"100%"} />}
                        {!isLoading && <Typography variant="body2" color='grey.400' mt={2}>
                            {coursesDetail?.data?.description?.Objective}
                        </Typography>}
                    </Box>
                )}

                {coursesDetail?.data?.description?.Outcomes && (
                    <Box my={5}>
                        {isLoading && <TextSkeleton line={4} width={"100%"} />}
                        {!isLoading && <BulletList title={"Outcome"} items={coursesDetail?.data?.description?.Outcomes} />}
                    </Box>
                )}

                {coursesDetail?.data?.description?.description && (
                    <Box my={5}>
                        <Typography variant="h5" >
                            Description
                        </Typography>
                        {isLoading && <TextSkeleton line={4} width={"100%"} />}
                        {!isLoading && <Typography variant="body2" color='grey.400' mt={2}>
                            {coursesDetail?.data?.description?.description}
                        </Typography>}
                    </Box>)
                }

                {coursesDetail?.data?.description?.Conclusion && (
                    <Box my={5}>
                        <Typography variant="h5" >
                            Conclusion
                        </Typography>

                        {isLoading && <TextSkeleton line={4} width={"100%"} />}
                        {!isLoading && <Typography variant="body2" color='grey.400' mt={2}>
                            {coursesDetail?.data?.description?.Conclusion}
                        </Typography>}
                    </Box>
                )}

                {/* <BulletList title={"Outcome"} items={OutcomeList} /> */}
                {/* <Box mt={5}>
                    <Typography variant="h5" mb={2}>
                        Course Structure
                    </Typography>
                    {CourseStructure.map((course, index) => (
                        <Box key={index} sx={{ display: "flex", alignItems: "stretch", pl: "10px" }}>

                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "12px" }}>

                                <Box
                                    sx={{
                                        width: "15px",
                                        height: "15px",
                                        bgcolor: "red.main",
                                        borderRadius: "50%",
                                        border: "4px solid #FFEDF1",
                                        boxShadow: "0px 4px 4px 0px #00000040"
                                    }}
                                />
                                {index !== CourseStructure.length - 1 && (
                                    <Box sx={{ width: "2px", bgcolor: "#FFEDF1", flexGrow: 1 }} />
                                )}
                            </Box>
                            <Box sx={{ ml: 3, flex: 1, pb: "5%" }}>
                                <Typography variant="body1" fontWeight={600}>
                                    {course.title}
                                </Typography>
                                <Typography variant="body2" color='grey.400' mt={2}>
                                    {course.content}
                                </Typography>
                            </Box>
                        </Box>


                    ))}
                </Box> */}


                {/* <BulletList title={"Prerequisites"} items={["UI/UX development is the process of designing", "Another list item"]} /> */}

            </Grid2>
            <Grid2 children size={{ xs: 12, lg: 4 }}>
                <SubscribedCard />
            </Grid2>

        </Grid2>
    )
}

export default UiUxDevelopement